import QCRuleModel from '../models/QCRuleModel';
import BaseStore from './BaseStore';
import { computed, extendObservable } from 'mobx';

class QCRuleStore extends BaseStore {
  qcTypeStore;

  constructor(transportLayer, qcTypeStore, qcFlagStore) {
    super(QCRuleModel, transportLayer);
    this.qcTypeStore = qcTypeStore;
    this.qcFlagStore = qcFlagStore;
  }

  @computed get itemsWithDetails() {
    return this.items.map(item => {
      let typeDetails = '';
      if (item.type === 1) {
        typeDetails = `Lower Threshold: ${item.threshold && item.threshold.lower_threshold}, ` +
          `Upper Threshold: ${item.threshold && item.threshold.upper_threshold}`;
      }
      if (item.type === 2) {
        typeDetails = `Max Change: ${item.step && item.step.max_change}, ` +
          `Interval: ${item.step && item.step.interval}`;
      }
      if (item.type === 3) {
        typeDetails = `Threshold: ${item.constant && item.constant.threshold}, ` +
          `Interval: ${item.constant && item.constant.interval}`;
      }
      if (item.type === 4) {
        typeDetails = `Reference: ${item.value_check && item.value_check.reference}`;
      }
      return {
        ...item,
        typeDetails,
        flag: this.qcFlagStore.items.find(flag => +flag.caption === +item.qc_flag)
      };
    });
  }

  mapQCRulesToDataSeries(dataSeriesIds, qcIds) {
    return this.transportLayer.mapQCRulesToDataSeries(dataSeriesIds, qcIds);
  }
  addDataSeries() {
  }

}

export default QCRuleStore;



// WEBPACK FOOTER //
// ./src/stores/QCRuleStore.js